import { AIAnalysisActions } from './actions';
import { FETCH_AI_ANALYSIS_REQUEST, FETCH_AI_ANALYSIS_SUCCESS, FETCH_AI_ANALYSIS_FAILURE } from './constants';
import { StockAnalysisData } from './types';

const initialStockData: AIAnalysisState = {
    data: {
        BasicInformation: {
            Symbol: '',
            Exchange: '',
            OrganName: '',
            ListedShares: 0,
            StockType: '',
            TradingDate: '',
            PriorClosePrice: 0,
            ReferencePrice: 0,
            CeilingPrice: 0,
            FloorPrice: 0,
        },
        TechnicalAnalysis: {
            PriceTrend: '',
            MovingAverages: '',
            RSI: '',
            SupportLevels: '',
            ResistanceLevels: '',
        },
        LiquidityAnalysis: {
            TradingVolume: '',
            ForeignTradingActivity: '',
        },
        FundamentalAnalysis: {
            MarketCap: '',
            PERatio: '',
            ROE: '',
        },
        PricePrediction: {
            ShortTerm: '',
            LongTerm: '',
        },
        InvestmentStrategy: {
            BuyPoints: '',
            SellPoints: '',
            StopLossLevels: '',
        },
        RisksToConsider: [],
    },

    loading: false,
    error: null,
};

export interface AIAnalysisState {
    data: StockAnalysisData;
    loading: boolean;
    error: any;
}
export const AIanalysisReudcer = (state = initialStockData, action: AIAnalysisActions): AIAnalysisState => {
    switch (action.type) {
        case FETCH_AI_ANALYSIS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_AI_ANALYSIS_SUCCESS: {
            return { ...state, loading: false, data: action.payload };
        }
        case FETCH_AI_ANALYSIS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
